function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 173.07 93.06"
}, props), React.createElement("g", {
  stroke: "currentColor",
  strokeMiterlimit: "10"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M41.1 27.41a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm6.17 0a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm6.16 0a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67z"
}), React.createElement("circle", {
  fill: "currentColor",
  cx: "51.76",
  cy: "32.03",
  r: "1.67"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M47.27 32a1.67 1.67 0 1 1-1.67-1.67A1.67 1.67 0 0 1 47.27 32zm-6.17 0a1.67 1.67 0 1 1-1.67-1.67A1.67 1.67 0 0 1 41.1 32zm18.5-4.59a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm6.16 0a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm7.02 0a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67z"
}), React.createElement("circle", {
  fill: "currentColor",
  cx: "71.11",
  cy: "32.03",
  r: "1.67"
}), React.createElement("circle", {
  fill: "currentColor",
  cx: "64.09",
  cy: "32.03",
  r: "1.67"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M59.6 32a1.67 1.67 0 1 1-1.67-1.67A1.67 1.67 0 0 1 59.6 32zm19.52-4.59a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm6.34 0a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm6.33 0a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm0 4.59a1.67 1.67 0 1 1-1.67-1.67A1.67 1.67 0 0 1 91.79 32zm6.34-4.59a1.67 1.67 0 1 1-1.67-1.67 1.67 1.67 0 0 1 1.67 1.67zm0 4.59a1.67 1.67 0 1 1-1.67-1.67A1.67 1.67 0 0 1 98.13 32zm-12.67 0a1.67 1.67 0 1 1-1.67-1.67A1.67 1.67 0 0 1 85.46 32zm-6.34 0a1.67 1.67 0 1 1-1.67-1.67A1.67 1.67 0 0 1 79.12 32z"
}), React.createElement("rect", {
  width: "107.61",
  height: "88.36",
  x: "15.43",
  y: "2.25",
  fill: "none",
  strokeWidth: "4.5",
  rx: "6.17",
  ry: "6.17"
}), React.createElement("path", {
  fill: "none",
  strokeWidth: "4.5",
  d: "M169.63 86.44L123 65.74V27.38l46.59-21a.85.85 0 0 1 1.19.78v78.51a.84.84 0 0 1-1.15.77z"
}), React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: "5",
  d: "M41.04 90.56v-19m27 19v-19m26 19v-19"
}), React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: "4.5",
  d: "M33.65 20.8h69.36v18.13H33.65zM4.92 11.41h10.51v20.72H4.92a2.67 2.67 0 0 1-2.67-2.67V14.08a2.67 2.67 0 0 1 2.67-2.67z"
}))));